import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export default function Logo() {
  return (
    <StaticImage
      src="../../archives/logo/Logo.png"
      alt="logo de promaco"
      placeholder="blurred"
      className="flex max-w-xs	"
    />
  );
}
